/* global axios */
import ApiClient from 'dashboard/api/ApiClient';

// `get` returns the list plus what the create form needs (eligible inboxes, the currency
// catalogue and the checklist declaration), so opening the tab is a single request.
// The three member actions are the steps that talk to Meta.
class WabaCurrencyMigrationsAPI extends ApiClient {
  constructor() {
    super('waba_currency_migrations', { accountScoped: true });
  }

  confirmChecklist(id, checklist) {
    return axios.patch(`${this.url}/${id}`, { checklist });
  }

  initiate(id) {
    return axios.post(`${this.url}/${id}/initiate`);
  }

  complete(id) {
    return axios.post(`${this.url}/${id}/complete`);
  }

  refresh(id) {
    return axios.post(`${this.url}/${id}/refresh`);
  }
}

export default new WabaCurrencyMigrationsAPI();
